





































































































































































































import { Component, Mixins } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import AccountModule from '@/store/modules/Account';
import GeneralModule from '@/store/modules/General';
import BalanceModule from '@/store/modules/Balance';
import AuthModule from '@/store/modules/Auth';
import GetBalanceModule from '@/store/modules/Profile';
import MarketingModule from '@/store/modules/Marketing';
import CreateAccountData from '@/data/CreateAccount';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import jwt_decode from 'jwt-decode';

@Component
export default class AddAgentView extends Mixins(ErrorHandleMixin) {
  AccountInstance = getModule(AccountModule, this.$store);

  GeneralInstance = getModule(GeneralModule, this.$store);

  AuthInstance = getModule(AuthModule, this.$store);

  BalanceInstance = getModule(BalanceModule, this.$store);

  GetBalanceInstance = getModule(GetBalanceModule, this.$store);

  MarketingInstance = getModule(MarketingModule, this.$store)

  mainKey = 0;

  UserData: any = { ...CreateAccountData.initialUserData() };

  expJwt: any;

  async created() {
    const expToken: any = jwt_decode(this.AuthInstance.token);
    this.UserData.currency = expToken.currency;
    this.UserData.role = 'MEMBER';
    this.UserData.source = this.AuthInstance.user.source;
    const { status, data } = await this.AccountInstance.GenerateUser({
      role: this.UserData.role,
      currency: this.UserData.currency,
    });
    if (status.code) {
      this.checkError(status);
    } else {
      this.UserData.username = data.username;
      this.UserData.pt.general = this.AuthInstance.user.pt.general;
      this.UserData.type = this.AuthInstance.user.type;
    }
  }

  async onSubmit() {
    this.GeneralInstance.toggleLoading(true);
    const resSelf = await this.MarketingInstance.Fetch();
    this.UserData.isFeature = await resSelf[0].isFeature;
    const {
      status: {
        code, message,
      },
      data,
    } = await this.AccountInstance.CreateAccount(this.UserData);
    if (code === 0) {
      await this.BalanceInstance.Refill({
        userId: data._id,
        type: 'TRANSFER',
        amount: this.UserData.balance,
        username: data.username,
        currency: this.UserData.currency,
        source: this.UserData.source,
      });
      this.UserData = { ...CreateAccountData.initialUserData() };
      this.mainKey += 1;
    }
    this.GeneralInstance.toggleLoading(false);
    this.GetBalanceInstance.GetBalance();
    this.GeneralInstance.ShowAlert({
      isAlert: true,
      alertMsg: message,
      alertColor: code === 0 ? 'success' : 'danger',
    });
  }
}
